export default __webpack_public_path__ + "static/media/routing.5dd0e65b.png";